<template>
  <div class="general-info">
    <label class="form__input">
      <span class="form__label">Mapped URL</span>
      <base-smart-input-autocomplete
        easyModel
        class="form__field"
        :options="autocompleteFilters"
        v-model="$parent.urlDataModel.url"
        placeholder="URL"
        :isNotValid="$parent.errorFields.url"/>
      <span class="form__error-message" v-if="$parent.errorFields.url">{{ $parent.errorFields.url }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Published URL</span>
      <base-smart-input-autocomplete
        easyModel
        class="form__field"
        :options="autocompleteFilters"
        v-model="$parent.urlDataModel.published_url"
        placeholder="Published URL"
        :isNotValid="$parent.errorFields.published_url"/>
      <span class="form__error-message" v-if="$parent.errorFields.published_url">{{ $parent.errorFields.published_url }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">URL Status</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.status}"
        placeholder="Select Status"
        :options="options.status"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.status"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.status">{{ $parent.errorFields.status }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Page Type</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.page_type}"
        placeholder="Select Page Type"
        :options="options.pageTypes"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.page_type"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.page_type">{{ $parent.errorFields.page_type }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Section</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        isSmartInput
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.section}"
        placeholder="Select Section"
        :options="options.sections"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.section"
        :max-height-list="300"
      />
      <span class="form__error-message" v-if="$parent.errorFields.section">{{ $parent.errorFields.section }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Is Optimized</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.is_optimized}"
        placeholder="Select Status"
        :options="activeOptions"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.is_optimized"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.is_optimized">{{ $parent.errorFields.is_active }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Content Brief Status</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.content_brief}"
        placeholder="Select Content Brief Status"
        :options="options.contentBrief"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.content_brief"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.content_brief">{{ $parent.errorFields.content_brief }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Writing Status</span>
      <base-select
        :headerStyle="{ 'border-width': '2px' }"
        alignLeft
        shiftLabelRight
        :smartInputStyle="{ 'padding-left': '20px' }"
        :class="{'form__field_error': $parent.errorFields.writing_status}"
        placeholder="Select Writing Status"
        :options="options.writingStatuses"
        :selectStyle="{ height: '60px !important' }"
        v-model="$parent.urlDataModel.writing_status"
        :max-height-list="450"
      />
      <span class="form__error-message" v-if="$parent.errorFields.writing_status">{{ $parent.errorFields.writing_status }}</span>
    </label>
    <label class="form__input">
      <span class="form__label">Target Publish Date</span>
      <base-date-picker-button v-model="$parent.urlDataModel.date" />
      <span class="form__error-message" v-if="$parent.errorFields.date">{{ $parent.errorFields.date }}</span>
    </label>
  </div>
</template>

<script>
import helper from '@/services/Helper'
import { mapState } from 'vuex'
import BaseSmartInputAutocomplete from '@/common/BaseSmartInputAutocomplete'

const ACTIVE_OPTIONS = [
  {
    label: 'Yes',
    value: 1
  },
  {
    label: 'No',
    value: 0
  }
]
export default {
  name: 'UrlGeneralInfo',
  data () {
    return {
      activeOptions: [...ACTIVE_OPTIONS]
    }
  },
  computed: {
    ...mapState('rankZoneCommon', {
      options (state) {
        const sections = state.sections.map(helper.convertListToOptions)
        const pageTypes = state.pageTypes.map(helper.convertListToOptions)
        const status = state.urlStatuses.map(helper.convertListToOptions)
        const contentBrief = state.contentBriefStatuses.map(helper.convertListToOptions)
        const writingStatuses = state.writingStatuses.map(helper.convertListToOptions)
        return {
          sections,
          pageTypes,
          status,
          contentBrief,
          writingStatuses
        }
      }
    }),
    ...mapState('urlCensus', {
      autocompleteFilters (state) {
        return (state.urlExamples.filter(v => v.toLowerCase().includes(this.$parent.urlDataModel.url.toLowerCase())) || []).map(v => ({ value: v, label: v }))
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .general-info {
    .form__field_error {
      &::v-deep .select__header-border {
        border-color: $rfx-red !important;
      }

      &::v-deep .select__selection,
      &::v-deep .select__placeholder {
        color: $rfx-red !important;
      }
    }

    .form__field {
      &::v-deep input {
        &::placeholder {
          padding-left: 30px;
        }
      }
    }
  }
</style>
